import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TRANSACTION_STATUSES } from '@/utility';

const useTranslatedTransactionStatuses = () => {
  const { t } = useTranslation();

  const getTranslatedStatus = useMemo(() => {
    return (status) => {
      if (!status || typeof status !== 'string') return '';

      const normalizedStatus = status.toLowerCase();

      switch (normalizedStatus) {
        case TRANSACTION_STATUSES.PENDING.toLowerCase():
          return t('payments.transactionStatus.pending');
        case TRANSACTION_STATUSES.SENT_UNCASHED.toLowerCase():
          return t('payments.transactionStatus.sentUncashed');
        case TRANSACTION_STATUSES.ACH_SENT.toLowerCase():
          return t('payments.transactionStatus.achSent');
        case TRANSACTION_STATUSES.SUCCESS.toLowerCase():
          return t('payments.transactionStatus.success');
        case TRANSACTION_STATUSES.ACH_RETURNED.toLowerCase():
          return t('payments.transactionStatus.achReturned');
        case TRANSACTION_STATUSES.VOIDED.toLowerCase():
          return t('payments.transactionStatus.voided');
        case TRANSACTION_STATUSES.ERROR.toLowerCase():
          return t('payments.transactionStatus.error');
        case TRANSACTION_STATUSES.ACH_RETURN_PENDING_RETURN_TO_BANK.toLowerCase():
          return t('payments.transactionStatus.achReturnPendingReturnToBank');
        case TRANSACTION_STATUSES.ACH_RETURN_AVAILABLE_TO_RECLAIM.toLowerCase():
          return t('payments.transactionStatus.achReturnAvailableToReclaim');
        case TRANSACTION_STATUSES.STARTED.toLowerCase():
          return t('payments.transactionStatus.started');
        default:
          return status;
      }
    };
  }, [t]);

  return { getTranslatedStatus };
};

export default useTranslatedTransactionStatuses;
